// FAQ toggle
const faqQuestions = document.querySelectorAll('.faq_item__question');
if (faqQuestions.length) {
    faqQuestions.forEach((question) => {
        question.addEventListener('click', () => {
            const parent = question.closest('.faq_item');
            if (parent) {
                parent.classList.toggle('active');
            }
        });
    });
}


// Review FAQ toggle
const reviewQuestions = document.querySelectorAll('.review_with_faq_wrapper__faqs .review_question');
if (reviewQuestions.length) {
    reviewQuestions.forEach((question) => {
        question.addEventListener('click', (event) => {
            const faqWrapper = event.currentTarget.nextElementSibling;
            if (faqWrapper) {
                faqWrapper.classList.toggle('active');
            }
            document.body.classList.add('faq-open');
        });
    });
}


// Close popup button
const closeBtn = document.querySelector('.review_with_heading_wrapper svg');
if (closeBtn) {
    closeBtn.addEventListener('click', () => {
        const popup = document.querySelector('.review_with_faq_pop_up');
        if (popup) popup.classList.remove('active');
        document.body.classList.remove('faq-open');
    });
}


// Custom description toggle
const descBtn = document.querySelector('.custom_description_btn');
if (descBtn) {
    descBtn.addEventListener('click', (event) => {
        const wrapper = event.currentTarget.closest('.custom-description');
        if (wrapper) {
            wrapper.classList.toggle('active');
        }
    });
}


(function () {
  function initStJaneUpsellSlider() {
    var sliders = document.querySelectorAll(
      '#rebuy-cart .rebuy-product-grid'
    );

    sliders.forEach(function (slider) {
      if (slider.dataset.sjSliderReady === 'true') {
        return;
      }

      slider.dataset.sjSliderReady = 'true';

      /* Mouse wheel → horizontal scroll */
      slider.addEventListener(
        'wheel',
        function (event) {
          if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            event.preventDefault();
            slider.scrollLeft += event.deltaY;
          }
        },
        { passive: false }
      );

      /* Mouse drag → horizontal scroll */
      var isDragging = false;
      var startX = 0;
      var startScrollLeft = 0;

      slider.addEventListener('mousedown', function (event) {
        isDragging = true;
        startX = event.pageX;
        startScrollLeft = slider.scrollLeft;

        slider.classList.add('sj-upsell-dragging');
      });

      slider.addEventListener('mousemove', function (event) {
        if (!isDragging) {
          return;
        }

        event.preventDefault();

        var distance = (event.pageX - startX) * 1.5;

        slider.scrollLeft = startScrollLeft - distance;
      });

      function stopDragging() {
        isDragging = false;
        slider.classList.remove('sj-upsell-dragging');
      }

      slider.addEventListener('mouseup', stopDragging);
      slider.addEventListener('mouseleave', stopDragging);
    });
  }

  /* Initial load */
  initStJaneUpsellSlider();

  /* Rebuy can render/re-render the cart */
  document.addEventListener('rebuy:smartcart.ready', function () {
    setTimeout(initStJaneUpsellSlider, 100);
  });

  document.addEventListener('rebuy:smartcart.show', function () {
    setTimeout(initStJaneUpsellSlider, 100);
  });

  document.addEventListener('rebuy:cart.change', function () {
    setTimeout(initStJaneUpsellSlider, 100);
  });

  /* Watch for Rebuy rebuilding the upsell */
  var observer = new MutationObserver(function () {
    initStJaneUpsellSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();